import React from "react";

const StylizedInfoSection = ({
  width = "100%",
  height = "100%",
  topColor = "#b9efff",
  bottomColor = "#88ddee",
  id = "infoGradient",
}) => {
  return (
    <svg
      viewBox="0 0 750 400"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      preserveAspectRatio="none"
    >
      <defs>
        <linearGradient id={id} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor={topColor} />
          <stop offset="100%" stopColor={bottomColor} />
        </linearGradient>
      </defs>

      <path
        d="M 734.103 12.230 C 727.489 29.527, 716.455 47.082, 703.532 60.867 C 692.755 72.363, 673.459 86.556, 659.865 92.987 L 653.500 95.998 369.623 95.999 L 85.746 96 78.342 91.913 C 51.088 76.869, 29.780 52.518, 17.812 22.740 L 14.500 14.500 14.232 43 C 14.084 58.675, 14.084 133.385, 14.232 209.022 L 14.500 346.543 17.785 353.215 C 21.358 360.472, 25.710 364.597, 33.670 368.271 L 38.500 370.500 367.500 370.768 C 548.450 370.915, 700.827 370.647, 706.116 370.172 C 717.127 369.183, 722.711 366.948, 728.448 361.233 C 733.397 356.304, 735.695 351.611, 736.951 343.871 C 738.075 336.944, 738.179 146.167, 737.108 56.730 L 736.500 5.960 734.103 12.230"
        fill={`url(#${id})`}
      />
    </svg>
  );
};

export default StylizedInfoSection;
